// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification-content-scroll {
  height: calc(100vh - 120px);
  overflow-y: auto;
}
@media screen and (max-width: 1199.98px) {
  .notification-content-scroll {
    height: calc(100vh - 165px);
  }
}
@media screen and (max-width: 767.98px) {
  .notification-content-scroll {
    height: calc(100vh - 175px);
  }
}
.notification-content-scroll .notification-content-wrap {
  padding: 0.313rem;
  height: 100%;
  position: relative;
}
.notification-content-scroll .notification-content-wrap .games-not-found span {
  display: block;
  text-align: center;
  word-break: break-word;
  background: var(--theme-secondary);
}
@media screen and (max-width: 767.98px) {
  .notification-content-scroll .notification-content-wrap {
    width: 100%;
    height: calc(100vh - 260px);
  }
}
.notification-content-scroll .notification-content-wrap .chat-card {
  margin: 0.313rem 0;
  border-radius: 0.625rem;
  background: var(--chatCardBg);
  padding: 0.625em;
  color: var(--white);
  word-break: break-word;
  position: relative;
}
.notification-content-scroll .notification-content-wrap .chat-card h4 {
  font-size: 0.875rem;
  font-weight: 600;
  padding-right: 0.313rem;
  cursor: pointer;
  margin: 0.4rem 0 0;
}
.notification-content-scroll .notification-content-wrap .chat-card p span {
  color: var(--white);
  opacity: 0.8;
  font-weight: 500;
}
.notification-content-scroll .notification-content-wrap .chat-card p {
  font-size: 0.8rem;
  color: var(--chatText);
  line-height: 1.2;
  margin: 0;
}
.notification-content-scroll .notification-content-wrap .chat-card .user-icon {
  width: 1rem;
  margin-right: 0.313rem;
}
.notification-content-scroll .notification-content-wrap .chat-card:first-child {
  margin-top: auto;
}
.notification-content-scroll .notification-content-wrap .chat-card .chat-card-head {
  position: absolute;
  right: 0.313rem;
  top: 0.313rem;
}
.notification-content-scroll .notification-content-wrap .chat-card .chat-card-head .chat-badge-lising {
  margin: 0 0.1rem;
  display: flex;
}
.notification-content-scroll .notification-content-wrap .chat-card .chat-card-head .chat-badge-lising svg {
  margin: 0 0.1rem;
}
.notification-content-scroll .notification-content-wrap .chat-card .chat-card-head .user-clr-one {
  color: var(--chatUserOne);
}
.notification-content-scroll .notification-content-wrap .chat-card .chat-card-head h4 {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: 90px;
}
.notification-content-scroll .notification-content-wrap .chat-card .chat-time {
  font-size: 0.625rem;
  font-weight: 300;
  color: var(--chatText);
}

.notification-header {
  background: var(--chatCardBg);
  margin-bottom: 1px;
}
.notification-header span {
  font-weight: 600;
  color: var(--chatText);
}`, "",{"version":3,"sources":["webpack://./src/components/layout/Header/components/Notifications/notifications.scss"],"names":[],"mappings":"AAAA;EACE,2BAAA;EACA,gBAAA;AACF;AAAE;EAHF;IAII,2BAAA;EAGF;AACF;AAFE;EANF;IAOI,2BAAA;EAKF;AACF;AADE;EACE,iBAAA;EACA,YAAA;EAIA,kBAAA;AAAJ;AAEM;EACE,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,kCAAA;AAAR;AAGI;EAfF;IAgBI,WAAA;IACA,2BAAA;EAAJ;AACF;AACI;EACE,kBAAA;EACA,uBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AACN;AAAM;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;AAER;AACQ;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;AACV;AAEM;EACE,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,SAAA;AAAR;AAEM;EACE,WAAA;EACA,sBAAA;AAAR;AAEM;EACE,gBAAA;AAAR;AAEM;EACE,kBAAA;EACA,eAAA;EACA,aAAA;AAAR;AACQ;EACE,gBAAA;EACA,aAAA;AACV;AAAU;EACE,gBAAA;AAEZ;AAEQ;EACE,yBAAA;AAAV;AAEQ;EACE,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAAV;AAGM;EACE,mBAAA;EACA,gBAAA;EACA,sBAAA;AADR;;AAOA;EACE,6BAAA;EACA,kBAAA;AAJF;AAKE;EACE,gBAAA;EACA,sBAAA;AAHJ","sourcesContent":[".notification-content-scroll{\n  height: calc(100vh - 120px);\n  overflow-y: auto;\n  @media screen and (max-width: 1199.98px){\n    height: calc(100vh - 165px);\n  }\n  @media screen and (max-width: 767.98px){\n    height: calc(100vh - 175px);\n  }\n  .empty-chat{\n    // width: 100%;\n  }\n  .notification-content-wrap{\n    padding: 0.313rem;\n    height: 100%;\n    // display: flex;\n    // flex-direction: column;\n    // justify-content: flex-start;\n    position: relative;\n    .games-not-found{\n      span{\n        display: block;\n        text-align: center;\n        word-break: break-word;\n        background: var(--theme-secondary);\n      }\n    }\n    @media screen and (max-width: 767.98px){\n      width: 100%;\n      height: calc(100vh - 260px);\n    }\n    .chat-card{\n      margin: 0.313rem 0;\n      border-radius: 0.625rem;\n      background: var(--chatCardBg);\n      padding: 0.625em;\n      color: var(--white);\n      word-break: break-word;\n      position: relative;\n      h4{\n        font-size: 0.875rem;\n        font-weight: 600;\n        padding-right: 0.313rem;\n        cursor: pointer;\n        margin: 0.4rem 0 0;\n      }\n      p{\n        span{\n          color: var(--white);\n          opacity: 0.8;\n          font-weight: 500;\n        }\n      }\n      p {\n        font-size: 0.8rem;\n        color:var(--chatText);\n        line-height: 1.2;\n        margin: 0;\n      }\n      .user-icon{\n        width: 1rem;\n        margin-right:0.313rem;\n      }\n      &:first-child{\n        margin-top: auto;\n      }\n      .chat-card-head{\n        position: absolute;\n        right: 0.313rem;\n        top: 0.313rem;\n        .chat-badge-lising{\n          margin: 0 0.1rem;\n          display: flex;\n          svg{\n            margin: 0 0.1rem;\n          }\n\n        }\n        .user-clr-one{\n          color: var(--chatUserOne);\n        }\n        h4{\n          text-overflow: ellipsis;\n          overflow: hidden;\n          white-space: nowrap;\n          max-width: 90px;\n        }\n      }\n      .chat-time{\n        font-size: 0.625rem;\n        font-weight: 300;\n        color: var(--chatText);\n      }\n    }\n  }\n}\n\n.notification-header{\n  background: var(--chatCardBg);\n  margin-bottom: 1px;\n  span{\n    font-weight: 600;\n    color: var(--chatText);\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
